/**
 * One source of truth for the Admin navigation order, route, and persisted
 * action key. The API exposes the same action keys through its role registry.
 */
export const ADMIN_SECTION_DEFINITIONS = [
    {key: "suppliers", path: "/admin/suppliers", action: "canManageAdminSuppliers", translationKey: "suppliers"},
    {key: "gl_codes", path: "/admin/gl_naturals", action: "canManageAdminGlCodes", translationKey: "gl_codes"},
    {key: "matters", path: "/admin/matters", action: "canManageAdminMatters", translationKey: "matter.matters"},
    {key: "departments", path: "/admin/departments", action: "canManageAdminDepartments", translationKey: "departments"},
    {key: "offices", path: "/admin/offices", action: "canManageAdminOffices", translationKey: "offices"},
    {key: "users", path: "/admin/users", action: "canManageAdminUsers", translationKey: "users"},
    {key: "roles", path: "/admin/roles", action: "canManageAdminRoles", translationKey: "roles.roles"},
    {key: "credit_cards", path: "/admin/ccards", action: "canManageAdminCreditCards", translationKey: "c-card", module: "c-card"},
    {key: "tax_codes", path: "/admin/tax-codes", action: "canManageAdminTaxCodes", translationKey: "tax_codes"},
    {key: "notifications", path: "/admin/notifications", action: "canManageAdminNotifications", translationKey: "admin_notifications"},
    {key: "clients", path: "/admin/clients", action: "canManageAdminClients", translationKey: "clients"},
];

export const adminSectionByKey = (key) =>
    ADMIN_SECTION_DEFINITIONS.find((section) => section.key === key) || null;
